import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
function RichTextEditor({
  label,
  defaultValue = '',
  highlighted = false
}: {
  label: string;
  defaultValue?: string;
  highlighted?: boolean;
}) {
  return <div data-id="element-548" data-mp="2hsjin1chakqs">
      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-549" data-mp="2hst6aia1wftb">
        {label}
      </label>
      <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-550" data-mp="2mjrr9v5zi22w">
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-551" data-mp="2ml2rxm44utps">
          <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-552" data-mp="2ct6wkitflhp9">
            Source
          </button>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-553" data-mp="22vseyfvrumvd" />
          {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-554" data-mp="2yjcz2m2nbfnn" data-mpi={i}>
              {ic}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-555" data-mp="33jr2trx7s3fv" />
          {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-556" data-mp="2ftdiknkvf8vu" data-mpi={i}>
              {ic}
            </button>)}
        </div>
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-557" data-mp="2kszrikto22yu">
          {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-558" data-mp="1x1ucg7vjvepl">
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-559" data-mp="2lt9tgbka4qt8" />
          {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-560" data-mp="2qki6dhktiub5" data-mpi={i}>
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-561" data-mp="1yvyhpbv3zw9d" />
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-562" data-mp="22w8pmu2gowqv">
            <option data-id="element-563" data-mp="27u0m81e1x71e">Styles</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-564" data-mp="27wmww9w8o2nu">
            <option data-id="element-565" data-mp="2cractkd6foqt">Format</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-566" data-mp="3ja8mtx9xa8af">
            <option data-id="element-567" data-mp="3o80jf4liiiky">Font</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-568" data-mp="3oamtbavvla6c">
            <option data-id="element-569" data-mp="1ckeyaefsodcs">Size</option>
          </select>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-570" data-mp="17lk7oqbl5ki4" />
          {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-571" data-mp="12ubx3qyirt3d" data-mpi={i}>
              {t}
            </button>)}
        </div>
        <textarea className={`w-full p-3 text-sm focus:outline-none resize-y min-h-[140px] ${highlighted ? 'bg-yellow-50' : 'bg-white'}`} defaultValue={defaultValue} data-id="element-572" data-mp="ovm0ecfm3vfj" />
      </div>
    </div>;
}
const creditOptions = ['3 hrs. Agency Law', '3 hrs. Comm. Standards', '3 hrs. Fair Housing', '3 hrs. General', '3 hrs. Disclosure', '3 hrs. Property Mgmt'];
const categoryOptions = ['Courses/Products', 'Single class', 'Package', 'Bundle'];
const smallDescDefault = `CS CE credit + Complies with current NAR cycle January 2025-December 2027

The Commissioner's Rule R4-28-1101 will be the primary focus of the class as it compares to the NAR Code Of Ethics for REALTORS®. There will be a review of the process of enforcement of both the Rules and Code of Ethics. Recent changes will be addressed as well as those that are often overlooked.

REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL ASSOCIATION.
Find Email Address: https://www.DesertSageSeminars.com/Arizona_Local_Associations`;
const fullDescDefault = `CS CE credit + Complies with current NAR cycle January 2025-December 2027

The Commissioner's Rule R4-28-1101 will be the primary focus of the class as it compares to the NAR Code Of Ethics for REALTORS®. There will be a review of the process of enforcement of both the Rules and Code of Ethics. Recent changes will be addressed as well as those that are often overlooked.

REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL ASSOCIATION.
Find Email Address: https://www.DesertSageSeminars.com/Arizona_Local_Associations

****This Class Will Comply With NAR Code of Ethics requirement PLUS 3 CE hrs. for Commissioner's Standards***`;
export function EditCourse() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-573" data-mp="151eoqu4teh1z">
      <div className="flex items-center justify-between" data-id="element-574" data-mp="1504pw2q514ua">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-575" data-mp="1jyf4dz9qelk3">
          {isEdit ? 'Edit Course' : 'Add Course'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/courses')} data-id="element-576" data-mp="1eysqropzr3ar">
          ← Back to Courses
        </Button>
      </div>

      <Card data-id="element-577" data-mp="22qhsfvopd44d">
        <CardContent className="pt-6" data-id="element-578" data-mp="22q81a4rx8qx3">
          <form className="space-y-5 max-w-2xl" data-id="element-579" data-mp="22n3r8qrrz0yi">
            <div data-id="element-580" data-mp="1xreokekgl3xz">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-581" data-mp="1xrwnjiyi9w9l">
                Position
              </label>
              <input type="text" defaultValue={isEdit ? '1' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-582" data-mp="vb4aht1gbqsc" />
            </div>

            <Input label="Name" defaultValue={isEdit ? 'Ethics & The Rules (with NAR Code of Ethics)' : ''} className="max-w-sm" data-id="element-583" data-mp="195n71nups02q" />

            <div data-id="element-584" data-mp="1j4coxgmm1kiz">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-585" data-mp="1n4d2z05srtpi">
                Category
              </label>
              <select defaultValue={isEdit ? 'Single class' : 'Courses/Products'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[160px]" data-id="element-586" data-mp="1s255eo42iy7y">
                {categoryOptions.map(c => <option key={c} data-id="element-587" data-mp="3mbtr6xcta470">{c}</option>)}
              </select>
            </div>

            <RichTextEditor label="Small Description" defaultValue={isEdit ? smallDescDefault : ''} highlighted={isEdit} data-id="element-588" data-mp="3hiqz6tnon2sx" />

            <RichTextEditor label="Full Description" defaultValue={isEdit ? fullDescDefault : ''} highlighted={isEdit} data-id="element-589" data-mp="37n74uboroc6a" />

            <div data-id="element-590" data-mp="45ozqc0dpj9k">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-591" data-mp="455mv9pl5l2e">
                Passing (%)
              </label>
              <input type="text" defaultValue={isEdit ? '80' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-592" data-mp="3v9x3r45tjqmo" />
            </div>

            <div data-id="element-593" data-mp="2ftx0tdb5dfgq">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-594" data-mp="2ftevlr6ibqwo">
                Credit
              </label>
              <select defaultValue={isEdit ? '3 hrs. Comm. Standards' : '3 hrs. Agency Law'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[180px]" data-id="element-595" data-mp="iwonhhwdm0ln">
                {creditOptions.map(c => <option key={c} data-id="element-596" data-mp="12jmbvs4h4yu1">{c}</option>)}
              </select>
            </div>

            <div data-id="element-597" data-mp="16jeocfwznp4o">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-598" data-mp="16m0v4dc220lu">
                Total Credits
              </label>
              <input type="text" defaultValue={isEdit ? '3' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-599" data-mp="xrcskuxv6x0q" />
            </div>

            <div data-id="element-600" data-mp="1q9qga1phl2m3">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-601" data-mp="1zmh5op9wczcx">
                Course No
              </label>
              <input type="text" defaultValue={isEdit ? 'CD17355' : ''} className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-602" data-mp="1vk2mg42bfxl4" />
            </div>

            <div data-id="element-603" data-mp="1gnbj5jpiu1q8">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-604" data-mp="1gowfnevebuqq">
                Publish
              </label>
              <select defaultValue="Yes" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-605" data-mp="1co2rcke1kdxb">
                <option data-id="element-606" data-mp="1lp0z9drlp5l6">Yes</option>
                <option data-id="element-607" data-mp="320ofa614oasq">No</option>
              </select>
            </div>

            {isEdit && <>
                <div data-id="element-608" data-mp="2x11r51jrha55">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-609" data-mp="2x1l74cpupogj">
                    Price
                  </label>
                  <input type="text" defaultValue="19.95" className="h-8 w-28 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-610" data-mp="2uqw9m8la8fba" />
                </div>

                <div data-id="element-611" data-mp="2kz8osqj8dwis">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-612" data-mp="2gz82yktsyj1p">
                    Crossed Price
                  </label>
                  <input type="text" defaultValue="" className="h-8 w-28 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-613" data-mp="2bytr0rp2yoye" />
                </div>

                <div className="flex items-center gap-2" data-id="element-614" data-mp="58vyr3sylrvb">
                  <input type="checkbox" id="availableInPackage" defaultChecked className="h-4 w-4 rounded border-slate-300 text-slate-800" data-id="element-615" data-mp="audcc829ggo" />
                  <label htmlFor="availableInPackage" className="text-sm text-slate-700" data-id="element-616" data-mp="cseoru0melde">
                    Available In Package
                  </label>
                </div>
              </>}

            <div className="pt-2" data-id="element-617" data-mp="3lyo4o9fl59aa">
              <Button type="submit" data-id="element-618" data-mp="3lzpr1a21xi7b">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}